// 接口基础地址
let reqApiUrl = ''
// 链接基础地址
let linkBaseUrl = ''
// 微信appId
let wxAppId = ''
// 开户基础地址
let olBaseUrl = ''

// scheme标识
let appScheme = ''
// app安卓包名
let appPackageName = ''
// 安卓app下载链接
let androidPackageUrl = ''
// 谷歌Play商店链接
let androidAppStoreLink = 'https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=vip.winbull.app'
// 苹果app商店链接
let iosAppStoreLink = 'https://apps.apple.com/hk/app/id1601778743'

let tradegoKey = ''
// 阿里、小米、腾讯、腾讯1，渠道ID分别为：71、72、73、74
let aliKey = 'zYjQBf'
let xiaomiKey = 'zMjQNz'
let tencentKey = 'NBVjMj'
let tencent1Key = '7RbmIr'
// 种子用户
let seedUserKey = 'jUJ36z'

switch (process.env.VUE_APP_ENV) {
  case 'dev':
    reqApiUrl = window.location.protocol + '//' + window.location.host
    linkBaseUrl = 'http://dev.winbull.cc:9080'
    olBaseUrl = 'http://dev.winbull.cc:9080'
    appScheme = 'winbull://'
    appPackageName = 'com.example.win_bull_app'
    androidPackageUrl = 'https://winbull-img2.oss-cn-guangzhou.aliyuncs.com/admin_mgr/winbullDev.apk'
    wxAppId = 'wx6d2c092386a0c2a9'
    tradegoKey = '6JZVny'
    break
  case 'sit':
    reqApiUrl = window.location.protocol + '//' + window.location.host
    linkBaseUrl = 'https://sit.winbull.cc:10443'
    olBaseUrl = 'https://sit.winbull.cc:10443'
    appScheme = 'winbull://'
    appPackageName = 'com.example.win_bull_app'
    androidPackageUrl = 'https://winbull-img2.oss-cn-guangzhou.aliyuncs.com/admin_mgr/winbullSit.apk'
    wxAppId = 'wx6d2c092386a0c2a9'
    tradegoKey = '6JZVny'
    break
  case 'uat':
    reqApiUrl = window.location.protocol + '//' + window.location.host
    linkBaseUrl = 'https://uat.winbull.cc'
    olBaseUrl = 'https://uat.winbull.cc'
    appScheme = 'winbull://'
    appPackageName = 'com.example.win_bull_app'
    androidPackageUrl = 'https://winbull-img2.oss-cn-guangzhou.aliyuncs.com/admin_mgr/winbullTest.apk'
    wxAppId = 'wx203fa3b5af8f51ef'
    tradegoKey = '6JZVny'
    break
  case 'prod':
    reqApiUrl = 'https://api.winbull8.com' // 注意：生产环境h5存放服务器与接口服务器不同源，此处需要运维处理跨域问题
    linkBaseUrl = 'https://api.winbull8.com'
    olBaseUrl = 'https://www.winbulls.com'
    appScheme = 'winbull://'
    appPackageName = 'vip.winbull.app'
    androidPackageUrl = 'https://winbull-img2.oss-cn-guangzhou.aliyuncs.com/admin_mgr/winbull.apk'
    wxAppId = 'wx6c7bd6940a6e2d9a'
    tradegoKey = '6JZVny'
    break
  default:
    reqApiUrl = '/devApi'
    linkBaseUrl = 'http://dev.winbull.cc:9080'
    olBaseUrl = 'http://dev.winbull.cc:9080'
    appScheme = 'winbull://'
    appPackageName = ''
    androidPackageUrl = 'https://winbull-img2.oss-cn-guangzhou.aliyuncs.com/admin_mgr/winbullDev.apk'
    wxAppId = 'wx6d2c092386a0c2a9'
    tradegoKey = '6JZVny'
    break
}

let helpDetailUrl = linkBaseUrl + '/h5/help/detail.html'
// 服务协议
let provisionStatementUrl = linkBaseUrl + '/h5/help/provision-statement.html'
// 隐私政策
let privacyPolicyUrl = linkBaseUrl + '/h5/help/privacy-policy.html'
// 内地开户、香港开户
let openAccountCnUrl = olBaseUrl + '/h5/openAccount/index_cn.html'
let openAccountHkUrl = olBaseUrl + '/h5/openAccount/index_hk.html'

// 【本地测试】内地开户、香港开户
// let openAccountCnUrl = linkBaseUrl + '/index_cn.html'
// let openAccountHkUrl = linkBaseUrl + '/index_hk.html'

const linkDict = {
  helpDetailUrl,
  provisionStatementUrl,
  privacyPolicyUrl,
  openAccountCnUrl,
  openAccountHkUrl
}

// 活动渠道专属key
const activityKey = {
  tradegoKey,
  aliKey,
  xiaomiKey,
  tencentKey,
  tencent1Key,
  seedUserKey
}

export {
  reqApiUrl,
  linkDict,
  activityKey,
  androidPackageUrl,
  androidAppStoreLink,
  iosAppStoreLink,
  appScheme,
  appPackageName,
  wxAppId
}
